import {  SvgIconProps } from '@mui/material';
import {ATTACHMENT_ICON_NAME, CHANNEL_ICON_NAME, iconList, REACTION_ICONS, LINK_ICONS} from './ccf-icon-list'


export interface CcfIconProps extends SvgIconProps { 
  iconName?: string,
  size?: string,
  attachmentIcon?: string,
  classes?: { container: string },
  svgIconStyles?: SvgIconProps,
  customStyle?: any,
}


export const CHANNEL_ICON_SIZE = {
  SMALL: 'S',
  MEDIUM: 'M',
  LARGE: 'L',
  EXTRA_SMALL: 'XS',
};

export const ATTACHMENT_ICON_SIZE = {
  SMALL: 'S',
  MEDIUM: 'M',
  LARGE: 'L',
};

/**
 * Component displays getSVG
 * @param iconName -string
 * @param size -string
 * @returns icon component for project
 * @example getSVG
 */ 
const getSvgIcons = (iconName: string, size: string, svgIconStyles?: SvgIconProps): any => {
  if (Object.values(CHANNEL_ICON_NAME).includes(iconName as CHANNEL_ICON_NAME) || Object.values(REACTION_ICONS).includes(iconName as REACTION_ICONS) || Object.values(LINK_ICONS).includes(iconName as LINK_ICONS) ) {
    return svgIconStyles ? iconList[iconName as CHANNEL_ICON_NAME](size, svgIconStyles): iconList[iconName as CHANNEL_ICON_NAME](size);
  }
};
/**
 * getAttachmentSVG
 * @param attachment -string
 * @param size -string (S, M or L)
 * @returns the attachment svg icon
 * @example getAttachmentSVG
 */ 
const getAttachmentSVG = (attachment: string, size: string): any => {
  if (Object.values(ATTACHMENT_ICON_NAME).includes(attachment as ATTACHMENT_ICON_NAME)) {
    return iconList[attachment as ATTACHMENT_ICON_NAME](size);
  }
};

/**
 * CcfIcon used to digital channel icon
 * @param props - CcfIcon
 * @example -- <CcfIcon />
 */
export function CcfIcon(props: CcfIconProps){
  const { attachmentIcon, iconName, classes, size, svgIconStyles, customStyle } = props;
  let fSize = '1.1rem';
  if (iconName) {
    if((iconName === 'apple-apps-reviews' || iconName === 'voice')){
      if(size === CHANNEL_ICON_SIZE.MEDIUM ){
        fSize = '2rem';
      }else if(size === CHANNEL_ICON_SIZE.LARGE){
        fSize =   '2.375rem';
      }
    } else {
      fSize= '1.5rem';
      if(size === CHANNEL_ICON_SIZE.MEDIUM ){
        fSize = '2.375rem';
      }else if(size === CHANNEL_ICON_SIZE.LARGE){
        fSize =   '3rem';
      }else if(size === CHANNEL_ICON_SIZE.EXTRA_SMALL){
        fSize =   '.875rem';
      }
    }
  }

  if (attachmentIcon) {
    if(size === ATTACHMENT_ICON_SIZE.MEDIUM){
      fSize = '1.5rem';
    }
  }

  const svgIcon = iconName && getSvgIcons(iconName, fSize ? fSize : CHANNEL_ICON_SIZE.SMALL, svgIconStyles);
  const attachmentSvg = attachmentIcon && getAttachmentSVG(attachmentIcon, fSize ? fSize : CHANNEL_ICON_SIZE.SMALL);

  return (
    classes?.container || customStyle ? <div className={classes?.container} style={customStyle}>
      {svgIcon}
      {attachmentSvg}
    </div> : <>
      {svgIcon}
      {attachmentSvg}
    </>
  );
}

export default CcfIcon;
